/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Billingservicev1Dependency } from '../models/Billingservicev1Dependency';
import { Billingservicev1Miscellanea } from '../models/Billingservicev1Miscellanea';
import { Billingservicev1SystemStat } from '../models/Billingservicev1SystemStat';
import { HttpFile } from '../http/http';

export class Billingservicev1Checks {
    'systemStat'?: Billingservicev1SystemStat;
    'dependencies'?: Array<Billingservicev1Dependency>;
    'miscellaneous'?: Array<Billingservicev1Miscellanea>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "systemStat",
            "baseName": "systemStat",
            "type": "Billingservicev1SystemStat",
            "format": ""
        },
        {
            "name": "dependencies",
            "baseName": "dependencies",
            "type": "Array<Billingservicev1Dependency>",
            "format": ""
        },
        {
            "name": "miscellaneous",
            "baseName": "miscellaneous",
            "type": "Array<Billingservicev1Miscellanea>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Billingservicev1Checks.attributeTypeMap;
    }

    public constructor() {
    }
}

